import { useFilterContext } from '../../filters/contexts/FilterProvider';
import type { Filter, FilterId } from '../../filters/types/filters';
import { formatFilterDisplay } from '../../filters/utils/formatFilterValue';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { ReportParameterConfig } from '../PageConfigProvider/page-reducer';

export type CoverSelectedParameter = { label: string; value: string };

function getDisplayValueForParameter(
  parameter: ReportParameterConfig,
  activeFilterMap: Map<FilterId, Filter>,
  groupMap: Map<string, Map<FilterId, Filter>>
): string {
  const filterMap = parameter.isPrimary
    ? activeFilterMap
    : groupMap.get(parameter.parameterId);
  if (!filterMap) return '';

  const filter = filterMap.get(parameter.filterId);
  if (!filter) return '';

  return formatFilterDisplay(filter);
}

export function useCoverSelectedParameters(): CoverSelectedParameter[] {
  const { config } = useTabContentConfig();
  const { activeFilterMap, filterState } = useFilterContext();

  const reportParameters = config.reportParameters ?? [];
  const groupMap = filterState.groupMap ?? new Map();

  const result: CoverSelectedParameter[] = [];

  for (const parameter of reportParameters) {
    const value = getDisplayValueForParameter(
      parameter,
      activeFilterMap,
      groupMap
    );
    if (value.trim()) {
      result.push({ label: parameter.name, value });
    }
  }

  return result;
}
